import axios from "axios";

export const getResetPassApi = (payload) => {
  // console.log(payload,"top payload")

  const prodUrl = process.env.REACT_APP_BASE_URL;
  return axios
    .post(prodUrl + "user-service/api/v1/users/settings/set-new-password/", {
      password1: payload.password1,
      password2: payload.password2,
      otp: payload.otp,
    })
    .then(function (response) {
      // console.log(response, "otp api response")
      return response;
    })
    .catch((error) => {
      return error;
    });
};
